import type { FC } from 'react';

import { EmailBodySection } from './EmailBodySection';
import { EmailFromSection } from './EmailFromSection';
import { EmailSaveAsDefaultCopySection } from './EmailSaveAsDefaultCopySection';
import { EmailSubjectSection } from './EmailSubjectSection';

import styles from './EmailForm.module.scss';

export const EmailForm: FC = () => {
	return (
		<div className={styles.emailForm}>
			<EmailFromSection />
			<EmailSubjectSection />
			<EmailBodySection />
			<EmailSaveAsDefaultCopySection />
		</div>
	);
};
